export default __webpack_public_path__ + "static/media/IntegrationMapsGps.62a0d827.pdf";